import React from "react";

const PageLoader = () => {
  return <div className="loader_spin"></div>;
};

export default PageLoader;
